<template>
    <div class="wrapper">
    <!-- <MainNavbar :transparent="false"></MainNavbar> -->
        <!-- <div class="section"> -->
            <div class="page-header page-header-smallTTT" style="">
                <parallax class="page-header-image"
                    style="background-image: url('img/sarel/loginpagegraphic.jpeg')">
                </parallax>
                <div class="content-center">
                    <h1 class="title">{{ constTxts.home_title }}</h1>
                    <div class="text-center">
                        <h3 class="title">{{ constTxts.home_subtitle }}</h3>
                    </div>
                    <div v-if="!this.isLoggedUser" class="sign-in-btn">
                        <a class="btn btn-primary btn-lg" href="/signin">
                            Sign in
                        </a>
                    </div>
                    <div v-if="this.isLoggedUser" class="sign-in-btn">
                        <a class="btn btn-primary btn-lg" href="/videos">
                            Videos
                        </a>
                    </div>

                </div>
                <!-- <div class="content-center">
                    <div class="row">
                        <div class="col-md-8 ml-auto mr-auto">
                            <h1 class="title">About Us</h1>
                            <h4>Meet the amazing team behind this project and find out more about how we work.</h4>
                        </div>
                    </div>
                </div> -->
            </div>
        <!-- </div> -->
        <!-- <div class="section">
        </div> -->
    </div>
</template>
<script>
  import { Card, Button, Badge, InfoSection, FormGroupInput, Checkbox } from '@/components';
  import { Select, Option } from 'element-ui'
  import MainNavbar from "../layout/MainNavbar.vue";

  import { mapGetters } from 'vuex'

  import {texts} from '@/constants/texts'

  export default {
    name: 'about-us',
    metaInfo: {
        title: 'Home',
    },
    bodyClass: 'about-us',
    components: {
        MainNavbar,
      Card,
      InfoSection,
      Badge,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [FormGroupInput.name]: FormGroupInput,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
        return {
            form: {
                firstName: '',
                email: '',
                speciality: ''
            }
        }
    },
    computed: {
        ...mapGetters(['isLoggedUser']),
        constTxts() {
            return texts
        }
    },
  }
</script>
<style>
.navbar {
    height: 70px;
    margin: 0 !important;
    padding: 0 !important;
}
.navbar-nav {
    /*flex-direction: row-reverse !important;
    justify-content: space-between;*/
    justify-content: flex-end;
    width: 100%;
    padding-top: 0;
    min-height: auto !important;
}
.navbar-nav .not-btn {
    color: black !important;
}
.content-wrapper {
    padding-top: 90px;
}
.sign-in-btn {
    margin-top: 2em;
}
.page-header {
    /*min-height:90vh*/
    min-height: calc(100vh - 70px);
}
.page-header .cover-image {
    object-fit: cover;
    /*background-size: contain;
    background-position: center center;*/
    /*background-position: center bottom;*/
    background-position-x: center;
    background-position-y: bottom;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-repeat: no-repeat;
    background-size: cover;
}
</style>
